"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToolbarRow = exports.ToolbarActions = exports.ToolbarContent = exports.ToolbarContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _architectMixins = require("@wealthmigrate/architect-mixins");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
} // ARCHITECT-CONTAINERS [ TOOLBAR > STYLE ] ####################################
// 1. DEPENDENCIES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 1.1. EXTERNAL DEPENDENCIES ..................................................
// 1.1. END ....................................................................
// 1.2. INTERNAL DEPENDENCIES ..................................................
// 1.2. END ....................................................................
// 1. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. FUNCTIONS ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 2. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3. STYLES +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// 3.1. MAIN CONTAINER .........................................................


var ToolbarContainer = _styledComponents["default"].header.withConfig({
  displayName: "indexstyle__ToolbarContainer",
  componentId: "sc-6w5q72-0"
})(["display:flex;align-items:center;justify-content:flex-end;flex-wrap:wrap;padding:var(--gutter-medium);@media ", "{flex-direction:column;padding:var(--gutter);margin-bottom:var(--gutter);};@media ", "{padding:var(--gutter);margin-bottom:var(--gutter);};@media ", "{};@media ", "{};"], _architectMixins._mixin_device.s, _architectMixins._mixin_device.m, _architectMixins._mixin_device.l, _architectMixins._mixin_device.xl); // 3.1. END ....................................................................
// 3.2. TOOLBAR CONTENT ........................................................


exports.ToolbarContainer = ToolbarContainer;

var ToolbarContent = _styledComponents["default"].div.withConfig({
  displayName: "indexstyle__ToolbarContent",
  componentId: "sc-6w5q72-1"
})(["flex:1;margin-right:var(--gutter-medium);h1{margin:0;}p{max-width:60%;", "}@media ", "{margin-right:0;h1{margin:0;}p{max-width:100%;", "}};@media ", "{p{max-width:100%;", "}};@media ", "{};@media ", "{};"], (0, _architectMixins._mixin_font_size)('medium'), _architectMixins._mixin_device.s, (0, _architectMixins._mixin_font_size)('normal'), _architectMixins._mixin_device.m, (0, _architectMixins._mixin_font_size)('normal'), _architectMixins._mixin_device.l, _architectMixins._mixin_device.xl); // 3.2. END ....................................................................
// 3.3. TOOLBAR ACTIONS ........................................................


exports.ToolbarContent = ToolbarContent;

var ToolbarActions = _styledComponents["default"].ul.withConfig({
  displayName: "indexstyle__ToolbarActions",
  componentId: "sc-6w5q72-2"
})(["flex:none;margin-right:var(--gutter-small)!important;", " @media ", "{};@media ", "{};@media ", "{};@media ", "{};"], _architectMixins._mixin_make_list, _architectMixins._mixin_device.s, _architectMixins._mixin_device.m, _architectMixins._mixin_device.l, _architectMixins._mixin_device.xl); // 3.3. END ....................................................................
// 3.4. TOOLBAR CONTENT ........................................................


exports.ToolbarActions = ToolbarActions;

var ToolbarRow = _styledComponents["default"].aside.withConfig({
  displayName: "indexstyle__ToolbarRow",
  componentId: "sc-6w5q72-3"
})(["flex:none;width:100%;", " justify-content:flex-end;background:var(--color-white);padding:var(--gutter-small);border-radius:var(--radius-small);form{width:100%;display:flex;div,button{&:not(:last-child){margin-right:var(--gutter-small);}}}@media ", "{flex:none;width:100%;flex-direction:column;li{margin-bottom:var(--gutter-small);width:100%;}};@media ", "{};@media ", "{};@media ", "{};"], _architectMixins._mixin_make_list, _architectMixins._mixin_device.s, _architectMixins._mixin_device.m, _architectMixins._mixin_device.l, _architectMixins._mixin_device.xl); // 3.4. END ....................................................................
// 3. END ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
// END OF FILE #################################################################


exports.ToolbarRow = ToolbarRow;